module.exports = __webpack_public_path__ + "static/tabs-number-do-febdbf9fd4974b05ad27d7d19b1267cc.png";